import { type ForwardRefExoticComponent, forwardRef } from 'react';

import { SliderActiveTrack } from './slider-active-track';
import { SliderHandle } from './slider-handle';
import { SliderHandles } from './slider-handles';
import { SliderRoot } from './slider-root';
import { SliderTrack } from './slider-track';
import type { SliderPropsInterface } from './types/slider.types';

/**
 * Sliders are interactive elements used to represent a range of values along a linear, numeric scale. They are typically found in filters and financial tools.
 *
 * @since 6.12.0
 */
export const Slider = forwardRef<HTMLDivElement, SliderPropsInterface>(
  (props: SliderPropsInterface, forwardedRef) => {
    return (
      <Slider.Root ref={forwardedRef} {...props}>
        <Slider.Track>
          <Slider.ActiveTrack />
        </Slider.Track>
        <Slider.Handles />
      </Slider.Root>
    );
  },
) as ForwardRefExoticComponent<SliderPropsInterface> & {
  Root: typeof SliderRoot;
  Track: typeof SliderTrack;
  Handle: typeof SliderHandle;
  Handles: typeof SliderHandles;
  ActiveTrack: typeof SliderActiveTrack;
};

Slider.Root = SliderRoot;
Slider.Track = SliderTrack;
Slider.Handle = SliderHandle;
Slider.Handles = SliderHandles;
Slider.ActiveTrack = SliderActiveTrack;

Slider.displayName = 'Slider';
